
import { Component, Prop, Vue } from "vue-property-decorator";
import axios from "axios";
import router from "@/router";
import { cacheSrv } from "./../services/cache";
import store from "./../store";
import { systemSrv } from '@/services/system';
import countryCodes from './../assets/codes';
import HeaderRewards from './common/HeaderRewards.vue'
@Component({
  components: {HeaderRewards}
})
export default class ForgotPassword extends Vue {
  emailFormSubmitted = false;
  authAPIUrl = this.$store.getters.config.authAPIUrl;
  data:any = {
    username: "",
    country: 'Malaysia'
  };
  submitted = false;
  processing = false;
  errorMessage = "";
  countriesRaw = countryCodes//[{n: 'Malaysia', p: 'MY', c: '+60'}]
  countries:any
  country:any={n: 'Malaysia', p: 'MY', c: '+60'}

  showCountries = true

  constructor() {
    super();
  }
  created() {
    this.data.username = this.$route.query["username"];
    if(this.data.username){
      if(this.data.username.startsWith("+")){
        this.showCountries = false
      }
    }
    this.countries = this.countriesRaw.sort((a, b) => (a.n.toLowerCase() > b.n.toLowerCase()) ? 1 : -1)


    setTimeout(()=>{
      (this.$refs["_username"] as HTMLElement).focus()
    })
     window.scrollTo(0,0);
  }
  updateCountry(ev){
    console.log("ev",ev)
    var c = ev.target.value
    this.country = this.countries.find((itm)=>{
      return itm.n==this.data.country
    })
  }
  login(){
    router.push({ path: "login"});
  }
  async forgotSubmit() {
    this.errorMessage = "";
    this.processing = true;
    let result;
    try {
      console.log("running api call");
      result = await axios.post(`${this.authAPIUrl}forgot-password`, {
        username: this.data.username, 
        country: this.countries.find((itm)=>{
          return itm.n==this.data.country
        })
      });
    } catch (e) {
      console.log("Error while resetting password", e);
      this.processing = false;
      this.errorMessage =
        "Error connecting to the server. Please check your internet connection and try again";
      return;
    }
    if (result.data) {
      let data = result.data;
      console.log("data", data, data["error"], data["memberNotFound"], data["success"]);
      if (data["error"]) {
        console.log("Error in resetting password");
        this.errorMessage = data['message']?data['message']:"Error while processing your request. Please try again";
        this.processing = false;
        return;
      }
      else if (data["memberNotFound"]) {
        this.processing = false;
        this.errorMessage = "Wrong mobile number. There is no account with this mobile number";
        setTimeout(()=>{
          (this.$refs["_username"] as HTMLElement).focus()
        },500)
      }
      else if(data["success"]){
        console.log("success!")
        this.processing = false;
        this.emailFormSubmitted = true
      }
      else{
        console.log("else catch all")
        this.processing = false;
        this.emailFormSubmitted = true
      }
    } else {
      console.log("Error in validating username. No data");
      this.processing = false;
    }
  }

}
